const MIN_GAP = 60;

export const getElementByQuerySelector = (id) => {
  const element = document.querySelector(`[itemid="${id}"]`);
  return element;
};

export const getRelativeTop = (mappedId) => {
  const element = getElementByQuerySelector(`question-${mappedId}`);

  if (element) {
    const rect = element.getBoundingClientRect();
    const containerRect = document.getElementById('documents-wrapper')?.getBoundingClientRect();
    const relativeTop = rect.top - (containerRect?.top || 0);

    return relativeTop;
  }
  return 0;
};

export const preparePositionedThreads = (threads, activeId?) => {
  let threadsWithTop = threads.map((threadItem) => {
    const top = getRelativeTop(threadItem.fieldUUID);
    return {
      ...threadItem,
      naturalTop: top,
    };
  });

  threadsWithTop = threadsWithTop.filter(
    ({ fieldUUID }) => !!getElementByQuerySelector(`question-${fieldUUID}`),
  );

  threadsWithTop.sort((a, b) => a.naturalTop - b.naturalTop);

  // If a comment is active (clicked), pin it to field top
  let positionedThreads: any[] = [];
  let activeIndex = threadsWithTop.findIndex((t) => t.fieldUUID === activeId);

  if (activeIndex !== -1) {
    const activeTop = threadsWithTop[activeIndex].naturalTop;
    let previousBottom = activeTop;

    // Position upward
    for (let i = activeIndex - 1; i >= 0; i--) {
      const upTop = Math.min(threadsWithTop[i].naturalTop, previousBottom - MIN_GAP);
      previousBottom = upTop;
      positionedThreads.unshift({ ...threadsWithTop[i], top: upTop });
    }

    // Active comment pinned to its field
    positionedThreads.push({
      ...threadsWithTop[activeIndex],
      top: activeTop,
      isActive: true,
    });

    // Position downward
    previousBottom = activeTop;
    for (let i = activeIndex + 1; i < threadsWithTop.length; i++) {
      const downTop = Math.max(threadsWithTop[i].naturalTop, previousBottom + MIN_GAP);
      previousBottom = downTop;
      positionedThreads.push({ ...threadsWithTop[i], top: downTop });
    }
  } else {
    // Fallback to regular spacing if nothing clicked
    let previousBottom = 0;
    positionedThreads = threadsWithTop.map((t) => {
      const top = Math.max(t.naturalTop, previousBottom + MIN_GAP);
      previousBottom = top;
      return { ...t, top };
    });
  }

  return positionedThreads;
};
